import { Navigate, Route, Routes } from 'react-router-dom'
import AppShell from './components/layout/AppShell.jsx'
import useAuth from './hooks/useAuth.js'
import { hasSupabaseConfig } from './lib/supabase.js'
import AuthPage, { FullScreenState, MembershipRequired, MissingConfiguration } from './pages/AuthPage.jsx'
import CharactersPage from './pages/CharactersPage.jsx'
import GuidedObservationPage from './pages/GuidedObservationPage.jsx'
import IdentifyPage from './pages/IdentifyPage.jsx'
import OverviewPage from './pages/OverviewPage.jsx'
import ReviewQueuePage from './pages/ReviewQueuePage.jsx'
import QuercusCharacterReviewPage from './pages/QuercusCharacterReviewPage.jsx'
import SetupPage from './pages/SetupPage.jsx'
import SourcesPage from './pages/SourcesPage.jsx'
import TaxaPage from './pages/TaxaPage.jsx'
import WorkspaceHomePage from './pages/WorkspaceHomePage.jsx'
import { ROUTES } from './config/workspaceConfig.js'

export default function App() {
  const { session, member, isSessionLoading, isMembershipLoading, authError, membershipError, signOut } = useAuth()

  if (!hasSupabaseConfig) return <MissingConfiguration />
  if (isSessionLoading) return <FullScreenState title="Opening botanical workspace…" description="Restoring your secure session." loading />
  if (!session) return <AuthPage initialError={authError} />
  if (isMembershipLoading) return <FullScreenState title="Verifying Botanical access…" description="Checking your active membership and role." loading />
  if (!member?.active) return <MembershipRequired session={session} error={membershipError} onSignOut={signOut} />

  return (
    <Routes>
      <Route element={<AppShell session={session} member={member} onSignOut={signOut} />}>
        <Route index element={<WorkspaceHomePage />} />
        <Route path={ROUTES.identify.slice(1)} element={<IdentifyPage />} />
        <Route path={ROUTES.knowledge.slice(1)} element={<OverviewPage />} />
        <Route path={ROUTES.taxa.slice(1)} element={<TaxaPage />} />
        <Route path={ROUTES.characters.slice(1)} element={<CharactersPage />} />
        <Route path={ROUTES.guidedPrototype.slice(1)} element={<GuidedObservationPage />} />
        <Route path={ROUTES.sources.slice(1)} element={<SourcesPage />} />
        <Route path={ROUTES.review.slice(1)} element={<ReviewQueuePage />} />
        <Route path={ROUTES.quercusReview.slice(1)} element={<QuercusCharacterReviewPage />} />
        <Route path={ROUTES.setup.slice(1)} element={<SetupPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  )
}
